module.exports = __webpack_public_path__ + "static/img/img(7).07a20a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/questionBank/img(7).png
// module id = IBtS
// module chunks = 1